const BaseView = require('../templates-base');
const FormatFactory = require('../../../../factory/formats');
const BrandTemplateThumbnailView = require('../../components/thumbnail/restricted');

module.exports = BaseView.extend({
  fetchType: 'brand',
  columnWidth: 255,
  numberOfTemplates: 0,

  initialize: function () { },

  show: async function () {
    if (!this.$el.find('.thumbnail-wrapper li').length && !this.loaded) {
      this.loaded = true;
      this.tool = INKIVE.Tool.getInstance();
      this.canvas = this.tool.editor.canvas;

      this.format = await FormatFactory.getCurrentFormat();
      BaseView.prototype.initialize.call(this, { format: this.format });
    }
  },

  loadData: async function (repeat, end) {
    this.end = end;
    this.repeat = repeat;

    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));

    const [matchingTemplates, siblingsFormats] = await Promise.all([
      this.getMatchingTemplates(),
      this.getSiblingsFormats()
    ]);
    const data = matchingTemplates.concat(siblingsFormats);

    this.onMoreData(data);
  },

  getMatchingTemplates: async function () {
    const formats = await FormatFactory.getFormats();
    const matchingFormats = formats.filter(format => this.formatMatchesCanvas(format));
    const matchingTemplates = await Promise.all(matchingFormats.map(format =>
      FormatFactory.getFormatTemplates(format)
    ));

    return matchingTemplates.reduce((result, templates, index) => {
      return result.concat(templates.map(template => ({
        format: matchingFormats[index],
        template
      })));
    }, []);
  },

  getSiblingsFormats: async function () {
    try {
      if (!this.format?.parent_format) return [];

      const formatSiblingsTemplates = await FormatFactory.getFormatSiblings(this.format);
      const parentFormat = await FormatFactory.getFormatById(this.format.parent_format);

      return formatSiblingsTemplates.map(template => ({
        format: parentFormat,
        template
      }));
    } catch (error) {
      return [];
    }
  },

  onMoreData: function (templatesInfo) {
    let createdThumbnailsCount = 0;

    this.$scrollDetect = this.$el.find('.thumbnail-wrapper .scrollDetect');

    const templatesKeys = Object.keys(templatesInfo);
    for (const key of templatesKeys) {
      const template = templatesInfo[key].template;
      const format = templatesInfo[key].format;
      createdThumbnailsCount++;
      this.appendBrandThumbnails(format, template);
    }

    INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));
    this.scrollRefresh();
    this.end();

    if (createdThumbnailsCount === 0) {
      const message = INKIVE.TranslateHelper.translate('tool.templates.no_similar_formats');
      this.$el.prepend(`<div class="no-templates">${message}</div>`);
    }
  },

  appendBrandThumbnails: function (format, template) {
    const $thumbnailView = $('<li>').addClass('thumbnail image loading')
      .data('key', 'brand-' + template.id)
      .insertBefore(this.$scrollDetect);

    /* eslint-disable no-new */
    new BrandTemplateThumbnailView({
      el: $thumbnailView,
      width: this.columnWidth,
      format,
      baseTemplate: template
    });
  }
});
